export const EXPERIENCE_TYPE = 'nikecom';
/**
 * Base URL for all track schemas.
 * @type {string}
 */
export const SCHEMA_BASE_URL =
  'https://www.nike.com/assets/measure/schemas/digital-product/dotcom/platform/web/classification/experience-event/experience/global-nav/event-type/track/event-name';
export const SCHEMA_FILE_PATH = 'version/LATEST/schema.json';

/**
 * Event names.
 * @type {string}
 */
export const EVENT_NAME_SEARCH_CLEAR_CLICKED = 'Search Clear Clicked';
export const EVENT_NAME_SEARCH_SUBMITTED = 'Search Submitted';
export const EVENT_NAME_SEARCH_PREVIEW_CLICKED = 'Search Preview Clicked';
export const EVENT_NAME_SEARCH_TYPEAHEAD_CLICKED = 'Search Typeahead Clicked';
export const EVENT_NAME_SEARCH_TYPEAHEAD_SHOWN = 'Search Typeahead Shown';
export const EVENT_NAME_SEARCH_POPULAR_SUGGESTION_CLICKED = 'Search Popular Suggestion Clicked';
export const EVENT_NAME_SHOPPING_MENU_CLICKED = 'Nav Shopping Menu Clicked';
export const EVENT_NAME_SHORTCUT_CLICKED = 'Nav Shortcut Clicked';
export const EVENT_NAME_BRAND_BAR_CLICKED = 'Nav Brand Bar Clicked';
export const EVENT_NAME_MEMBERSHIP_CLICKED = 'Nav Membership Clicked';
export const EVENT_NAME_ACCOUNT_CLICKED = 'Nav Account Clicked';
export const EVENT_NAME_CART_CLICKED = 'Nav Cart Clicked';
export const EVENT_NAME_GEO_MISMATCH_CLICKED = 'Nav Geo Mismatch Clicked';
export const EVENT_NAME_GEO_SELECTION_AUTO_OPENED = 'Nav Geo Selection Auto Opened';
export const EVENT_NAME_GEO_SELECTION_CLICKED = 'Nav Geo Selection Clicked';
export const EVENT_NAME_HELP_CLICKED = 'Nav Help Clicked';
export const EVENT_NAME_FOOTER_CLICKED = 'Nav Footer Clicked';
export const EVENT_NAME_STORE_LOCATOR_CLICKED = 'Find A Store Clicked';
export const EVENT_NAME_SEARCH_OPEN_CLICKED = 'Search Opened';
export const EVENT_NAME_SEARCH_CLOSE_CLICKED = 'Search Closed';
export const EVENT_NAME_SEARCH_RECENT_CLICKED = 'Search Recent Clicked';
export const EVENT_NAME_SEARCH_RECENT_DELETED = 'Search Recent Deleted';
/**
 * Maps the event names to their schema URL path.
 * The URL is built in the sink function.
 * @see sinks.js
 * @type {Object}
 */
export const SCHEMA_MAP = {
  [EVENT_NAME_ACCOUNT_CLICKED]: 'nav-account-clicked',
  [EVENT_NAME_BRAND_BAR_CLICKED]: 'nav-brand-bar-clicked',
  [EVENT_NAME_CART_CLICKED]: 'nav-cart-clicked',
  [EVENT_NAME_FOOTER_CLICKED]: 'nav-footer-clicked',
  [EVENT_NAME_GEO_MISMATCH_CLICKED]: 'nav-geo-mismatch-clicked',
  [EVENT_NAME_GEO_SELECTION_AUTO_OPENED]: 'nav-geo-selection-auto-opened',
  [EVENT_NAME_GEO_SELECTION_CLICKED]: 'nav-geo-selection-clicked',
  [EVENT_NAME_HELP_CLICKED]: 'nav-help-clicked',
  [EVENT_NAME_MEMBERSHIP_CLICKED]: 'nav-membership-clicked',
  [EVENT_NAME_SEARCH_CLEAR_CLICKED]: 'search-clear-clicked',
  [EVENT_NAME_SEARCH_CLOSE_CLICKED]: 'nav-search-close',
  [EVENT_NAME_SEARCH_OPEN_CLICKED]: 'nav-search-open',
  [EVENT_NAME_SEARCH_POPULAR_SUGGESTION_CLICKED]: 'search-popular-suggestion-clicked',
  [EVENT_NAME_SEARCH_PREVIEW_CLICKED]: 'search-preview-clicked',
  [EVENT_NAME_SEARCH_RECENT_CLICKED]: 'nav-search-recent-submit',
  [EVENT_NAME_SEARCH_RECENT_DELETED]: 'nav-search-recent-removed',
  [EVENT_NAME_SEARCH_SUBMITTED]: 'search-submitted',
  [EVENT_NAME_SEARCH_TYPEAHEAD_CLICKED]: 'search-typeahead-clicked',
  [EVENT_NAME_SEARCH_TYPEAHEAD_SHOWN]: 'search-typeahead-shown',
  [EVENT_NAME_SHOPPING_MENU_CLICKED]: 'nav-shopping-menu-clicked',
  [EVENT_NAME_SHORTCUT_CLICKED]: 'nav-shortcut-clicked',
  [EVENT_NAME_STORE_LOCATOR_CLICKED]: 'find-a-store-clicked',
};

export const SEGMENT_WRITE_KEY_PRODUCTION = '2iv4Qa7rFEipAs4iE850BkBpTYQvlAFZ';
export const SEGMENT_WRITE_KEY_STAGING = 'POwa4r8vBBSw7xdQZ0dqGlNuyaT7Y7pZ';
